import { FC, PropsWithChildren } from 'react';

import { StyleSheet } from 'react-native';

import SanityBlockRenderer from 'components/sanity-block-renderer';
import { useAuthContext } from 'state/auth';
import { primitive, spacing } from 'styles/constants';

import { useLoyaltyWalmart } from '../use-loyalty-walmart';

const styles = StyleSheet.create({
  terms: {
    marginBottom: spacing.$5,
  },
});

const linkStyles = {
  variant: 'copyTwo',
  fontSize: 'xs',
  textDecorationLine: 'underline',
  color: `${primitive.$bbqBrown}`,
};

const termsTextProps = {
  fontFamily: 'Flame-RegularSans',
  fontSize: 'xs',
  color: primitive.$blackOpacity50,
  style: styles.terms,
};

export const WalmartTerms: FC<PropsWithChildren<{}>> = () => {
  const { isAuthenticated, loading: authLoading } = useAuthContext();
  const { data, loading } = useLoyaltyWalmart();

  if (loading || authLoading) {
    return null;
  }

  const { termsAndConditionsRaw, termsAndConditionsAuthenticatedRaw } = data?.landingPage || {};
  const content = isAuthenticated
    ? termsAndConditionsAuthenticatedRaw ?? termsAndConditionsRaw
    : termsAndConditionsRaw;
  return (
    <SanityBlockRenderer textProps={termsTextProps} content={content} linkProps={linkStyles} />
  );
};
